export async function fetchDrones(token) {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/drones`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

export async function addDroneApi(token, droneName, droneId) {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/drones`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ drone_name: droneName, drone_id: droneId })
  });
  return res.json();
}

export async function deleteDroneApi(token, id) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/drones/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` }
  });
}

export async function updateDroneApi(token, id, route, telemetry) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/drones/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ route, telemetry })
  });
}
